import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type DeclineSubmissionInput = {
  id: string;
  note?: string;
};

// POST /api/admin/submissions/:id/decline
//
// Pessimistic — decline writes decision_note + dispatches a partner email;
// no optimistic surface. Invalidates submissions.list + submissions.detail
// only.
export function useDeclineSubmission() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, DeclineSubmissionInput>({
    mutationFn: ({ id, note }) =>
      apiFetch<void>(`/admin/submissions/${encodeURIComponent(id)}/decline`, {
        method: "POST",
        body: JSON.stringify({ note }),
      }),
    onError: (err) => {
      toast.error(err.message ?? "Failed to decline submission");
    },
    onSettled: (_data, _err, { id }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.submissions.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.submissions.detail(id) });
      // Sub-bucket 17 — refresh the queue's 4 metric cards.
      queryClient.invalidateQueries({
        queryKey: queryKeys.submissions.aggregate(),
      });
    },
  });
}
